export enum ProgressState {
  Running = "Running",
  Completed = "Completed",
  Failed = "Failed",
  Canceled = "Canceled",
}
